export default "__VITE_ASSET__BrwF4k35__"